//Componentes generales
import { useEffect, useContext, useRef, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import ReqList from '../../components/ReqList/ReqList';
import { STATES } from "../../utils/states";

//Permisos
import {VER_TODOS_REQUERIMIENTOS} from "../../utils/permisos";

//Estilos
import './Home.css';

//Contexto
import controlGLBContext from '../../context/controlGLB/controlGLBContext';
import controlContext from '../../context/control/controlContext';
import authContext from '../../context/authentication/authContex';
import usuariosContext from '../../context/usuarios/usuariosContext';
import agregarReqContext from '../../context/agregarReq/agregarReqContext';
import productsContext from '../../context/productos/productsContext';

import clienteAxios from '../../config/axios';
import { addToDate } from '../../utils/funciones';

// Alertas
import Swal from 'sweetalert2'
import { useState } from 'react';
import categoriasRRHHContext from '../../context/categoriasRRHHContext/categoriasRRHHContex';

/* 
    Vista donde se gestiona toda la lógica de listado de requerimientos. Es la vista principal de toda la aplicación.
        Donde props no se encuentra en uso.
*/
function Home(props) {
    const location = useLocation();
    //Este CODFOR - NROFOR de OT proviene desde ProcsProgramadosList al presionar el botor "Ver OT".
    const [OTtoFind,setOTtoFind] = useState(localStorage.getItem('OTtoFind') || location?.state?.OTtoFind || null);
    
    //Este CODFOR - NROFOR de OT proviene desde ProcsProgramadosList al presionar el botor "Ver OT".
    // const ordenesTrabajoFromLocalStorage = localStorage.getItem('ordenesTrabajo');
    const ordenesTrabajoFromLocalStorage = useMemo(()=> localStorage.getItem('ordenesTrabajo'),[]);

    //Context auth
    const aContext = useContext(authContext);
    const { usuario, checkIfSupervisor } = aContext;

    //Context usuarios
    const uContext = useContext(usuariosContext);
    const { userListView, actualizarUserListView, userVisualiza } = uContext;

    const firstLoadRef = useRef(true);

    //Context control requerimientos
    const cContext = useContext(controlContext);
    const {
        listTDoc,
        filtrosRango,
        filtrosEstado,
        modificarFiltrosEstado,
        modificarFiltrosRango,
        iniciarFiltros,
        getProductsByNroFor,
        getODTByNrofor,
        filtrar,
        initialState
    } = cContext;

    //Contexto general generación de informe
    const gContext = useContext(controlGLBContext);
    const { generarInformeReqPDF, modificarEstado, getFilesByTDoc, enviarReqApi } = gContext;

    //Context productos
    const pContext = useContext(productsContext);
    const { products, actualizarProducts } = pContext;

    //Context Edit Requerimiento
    const addContext = useContext(agregarReqContext);
    const { guardarRequerimiento, editarRequerimientoBE } = addContext;

    const [listTDocHome, setListTDocHome] = useState(undefined);

    const {NroForOT, editOT} = location.state || {};

    const handlerIniciarlizarFiltros = async () => {
        const state = ["PENDIENTE", "ENPROCESO"];
        // El Home solo necesita las ODTs recientes: se acota fecAlt a los ultimos 6 meses
        // para que el backend no traiga la coleccion entera.
        const filtrosRangoHome = {
            ...initialState.filtrosRango,
            fecAlt: { desde: addToDate(new Date(), -6, 'month'), hasta: new Date() }
        };
        await iniciarFiltros(state, usuario, undefined, undefined, undefined, undefined, undefined, filtrosRangoHome);
    }

    /* 
        Manejador que comprueba los permisos que posee el usuario en sesión para un rol enviado por parametro.
        Donde roles_autorizados es el rol a comprobar.
        Retorna true si esta autorizado, false si no.
    */
    const handleCheckPermisos = (roles_autorizados) =>{
        let autoriza = false;
        for (const element of roles_autorizados) {
            if (usuario.userType.some(item => item.typeName === element)){
                autoriza = true;
            }
        }
        return autoriza;
    }

    /* 
        Manejador para la modificación rapida de un requerimiento. Se utiliza en 3 ocaciones, edición del estado de autorización, notas privadas y notas publicas.
        Donde reqe es el requerimiento a actualizar.
        upd es lo modificado.
    */
    const handleModifyStateReq = async (reqe, upd) =>{
        const resp = await modificarEstado(reqe, usuario, upd);        
        return resp;
    }

    /* 
        Manejador que recupera todos los items de un requerimiento dado por parametro.
        Donde tDocCodFor es el Codfor del requerimiento (normalmente REQ).
        tDocNrofor es el Nrofor del requerimiento.
    */
    const handlerVerReqDetails = async (tDocCodFor, tDocNroFor) => {
        return await getProductsByNroFor(tDocCodFor, tDocNroFor);
    }

    /* 
        Manejador que recupera los archivos adjuntados a un requerimiento especificado por parametro.
        Donde req es el requerimiento de donde recuperar los archivos.
    */
    const handlerRecuperaFiles = async (req) => {
        return await getFilesByTDoc(req);
    }

    /* 
        Manejador encargado demodalReq generar un archivo pdf con formato brindado en el back-end. Se descarga automaticamente y se abre en una nueva pestaña.
        Donde doc es el archivo a generar.
        user es el usuario en sesión que llama a la función.
    */
    const handlerGeneraPDF = async (doc, user, withLogo = false, formato) =>{
        await generarInformeReqPDF(doc, user, withLogo, formato);
    }

    /* 
        Función encargada de aplicar y/o inicializar los filtros.
        Donde filtrosProp son los filtros a aplicar.
        signal no se encuentra actualmente en uso.
        El parametro recibido es un objeto que contiene los filtros de estado y de rango, se aplican cada uno con su respectiva función.
    */
    const apFiltros = async (filtrosProp) => {
        modificarFiltrosEstado(filtrosProp.filterEstado);
        modificarFiltrosRango(usuario._id, filtrosProp.filterRango);
    }

    /* 
        Función encargada de validar los campos del requerimiento a guardar. Valida que este ingresado el titulo, que no existan items sin cantidad y que por lo menos contenga un item con cantidad.
        Donde r es el requerimiento a validar.
        i son los items del requerimiento a validar.
        Se llama al momento de guardar.
    */
    const validacionesCampos = (r, i) => {
        let resp = '';
        if(r.title === ""){
            resp = "Falta ingresar titulo de requerimiento";
        }
        return resp;
    }

    /* 
        Manejador encargado de guardar un nuevo requerimiento. Realiza validaciones y si no la supera no se guarda el requerimiento.    
            Donde requeriment es el requerimiento a guardar.
                  items son los items del requerimiento.
                  files son los archivos adjuntos del requerimiento.
    */
    const handleSaveReq = async (requeriment, items, files) =>{
        const msj = validacionesCampos(requeriment, items);
        if (requeriment !== undefined && requeriment !== null) {
            if (msj === "") {
                const resp = await guardarRequerimiento(requeriment, items, usuario, files);
                Swal.fire({
                    title: `Se guardo un nuevo requerimiento`,
                    icon: 'success',
                    text: `El numero de requerimiento es : ${resp.tDocNroFor}`,
                    showConfirmButton: true,
                    allowEnterKey: true
                });
            }else{
                Swal.fire({
                    title: msj,
                    icon: 'warning',
                    showConfirmButton: true,
                    allowEnterKey: true
                });
            }
        }
    }

    /* 
        Manejador encargado de guardar los cambios realizados en la edición de un requerimiento. Realiza validaciones y si no la supera no se guarda las modificaciones del requerimiento.  
            Donde requeriment es el requerimiento a guardar.
                  items son los items del requerimiento.
                  files son los archivos adjuntos del requerimiento.
                  fileBase son los archivos originales antes de la edición.
    */
    const handdleEdit = async (requeriment, items, files, fileBase, fromAction = 'normal')=>{
        const msj = validacionesCampos(requeriment, items);

        if (requeriment !== undefined && requeriment !== null) {
            if (msj === "") {
                const resp = await editarRequerimientoBE(requeriment, items, files, fileBase, usuario, fromAction);
                if(resp) Swal.fire({
                    title: `Se modificó la Orden de Trabajo`,
                    icon: 'success',
                    text: `El número de orden de trabajo modificada es : ${resp?.tDocNroFor ?? requeriment.tDocNroFor}`,
                    showConfirmButton: true,
                    allowEnterKey: true
                });
            }else{
                Swal.fire({
                    title: msj,
                    icon: 'warning',
                    showConfirmButton: true,
                    allowEnterKey: true
                });
            }
        }
    }

    /* 
        Manejador encargado de enviar el requerimiento a Softland mediante llamada a rutas del webService.
            Donde data es el requerimiento a enviar.
    */
    const handdleEnviaApi = async (data) =>{
        try{
            await enviarReqApi(data);

            Swal.fire({
                title: `Enviado`,
                icon: 'success',
                text: `Requerimiento ${data.tDocCodFor}-${data.tDocNroFor} enviado correctamente`,
                showConfirmButton: true,
                allowEnterKey: true
            });
        }catch(err){
            console.log("Error en enviar a Servidor");
            Swal.fire({
                title: err.message,
                icon: 'error',
                showConfirmButton: true,
                allowEnterKey: true
            });
        }
        
    }
    
    useEffect(() => {
            let resFiltered;
            if(ordenesTrabajoFromLocalStorage && ordenesTrabajoFromLocalStorage != null && ordenesTrabajoFromLocalStorage != 'null' && listTDoc == null) resFiltered = filtrar(JSON.parse(ordenesTrabajoFromLocalStorage), filtrosEstado)
            else resFiltered = filtrar(listTDoc, filtrosEstado)
            //Si el usuario logueado es supervisor muestra solo aquellas ODTs cuyos procedimientos programados del que parten estan seteados como visibles para supervisor.
            if(checkIfSupervisor() && listTDoc) resFiltered = resFiltered.filter(odts => odts.supervisorVisible);
            if(listTDoc) setListTDocHome(resFiltered);        
            else if(ordenesTrabajoFromLocalStorage == null || ordenesTrabajoFromLocalStorage == "null") setListTDocHome(undefined) //Solo si Home no se renderiza al presionar VerODT en ProcsProgramados, se setea undefined si listTDoc es nulo.
    }, [listTDoc, filtrosEstado])

    /* 
        Disparador que actualiza la lista de usuarios disponibles e inicializa los filtros al momento de renderizar el componente.
    */
    useEffect(() => {
        if(usuario) actualizarUserListView(usuario);
        // handlerIniciarlizarFiltros();
    }, []);

    /* 
        Disparador que actualiza la lista de productos disponibles al momento de renderizar el componente.
    */ 
    useEffect(() => {
        if(localStorage.getItem('OTtoFind')) localStorage.removeItem('OTtoFind');
        else if(!OTtoFind) handlerIniciarlizarFiltros(); //Si no se obtiene que ot buscar, se inicializan nuevamente los filtros.

        // El pintado instantaneo con la cache de 'ordenesTrabajo' ya lo hace el otro effect
        // (linea 257) pasandola por filtrar(); hacerlo aca de nuevo sin filtrar pisaba ese
        // resultado con la lista completa (incluyendo FINALIZADA) mientras carga la real.

        const fn = async () => {
            await actualizarProducts();
        }
        fn();
    }, []);

    return (
        <div className='container-test'>
            <ReqList 
                currentUser={usuario}
                productList={products} 
                listTDoc={listTDocHome} 
                userListView={userListView} 
                filtros={{filtrosRango, filtrosEstado}} 
                editar={handdleEdit}
                aplicarFiltros={apFiltros} 
                guardarComo={handleSaveReq}
                sendToAPI={handdleEnviaApi}
                generaPDF={handlerGeneraPDF}
                verDetalle={handlerVerReqDetails} 
                checkPermisos={handleCheckPermisos}
                modificarEstado={handleModifyStateReq} 
                recuperaFilesDetalle={handlerRecuperaFiles}
                editOT={editOT}
                nroforToEdit={NroForOT}
                OTtoFind={OTtoFind}
                ordenesTrabajoFromLocalStorage={ordenesTrabajoFromLocalStorage}                
            />
        </div>
    );
}

export default Home